import { NgModule } from 'ng-metadata/core';
import { BadgeComponent } from './badge.component';

/**
 * @ngdoc module
 * @name mw.components.badge
 * @description
 *
 * Expandable/Collapsible container with header and optional footer
 */
@NgModule({
    declarations: [ BadgeComponent ]
})
export class BadgeModule {}



// WEBPACK FOOTER //
// ./src/lib/components/badge/badge.module.ts